import { IEvaluationItemType } from "models/Bid/EvaluationItemTypeModel";
import { BaseService } from "./base.service";

class EvaluationItemTypeServiceInternal extends BaseService {
	getEvaluationItemTypeList = async (
		evaluationPhaseId: number = 0
	): Promise<IEvaluationItemType[]> =>
		this.callApi<IEvaluationItemType[]>(
			`EvaluationItemType/GetEvaluationItemTypeList/${evaluationPhaseId}`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			false
		);
}

export const EvaluationItemTypeService =
	new EvaluationItemTypeServiceInternal();
